import React, { useState, useCallback } from 'react';
import { Button, Grid, withTheme } from '@material-ui/core';
import moment from '../moment-hawaii';
import DatePickerDropdown from './atom/DatePickerDropdown';
import PriceSlider from './atom/PriceSlider';
import FancyPlayerCountSelect from './fancy/FancyPlayerCountSelect';
import FancyButtongroupSelect from './fancy/FancyButtongroupSelect';
import { useIslands } from '../hooks/useIslands';

const GOLF_TIME_RANGES = [
    { id: 0, name: '7am-11am', value: { fromTime: '07:00', toTime: '11:00' } },
    { id: 1, name: '10am-2pm', value: { fromTime: '10:00', toTime: '14:00' } },
    { id: 2, name: '1pm-5pm', value: { fromTime: '13:00', toTime: '17:00' } },
    { id: 3, name: 'Any', value: { fromTime: '', toTime: '' } }
];

const GolfActivityFilters = ({
    filters,
    setFilters,
    notAllFiltersSelected,
    loadActivities,
    loading
}) => {
    const [isOpen, setIsOpen] = useState(true);
    const [islandOptions] = useIslands();

    const setPriceCallback = useCallback(
        (event, values) => {
            setFilters({
                ...filters,
                price: {
                    fromPrice: Math.min(...values),
                    toPrice: Math.max(...values)
                }
            });
        },
        [setFilters, filters]
    );

    const isMobileSize = window.matchMedia('(max-width: 600px)').matches;
    return (
        <>
            {!isOpen && (
                <Grid item container alignItems="center" id="sidemenu-trigger">
                    {!notAllFiltersSelected && (
                        <Grid item>
                            {moment(filters.checkInDate).format('ddd, MMM D')} • {filters.guests}{' '}
                            players • {filters.islands}
                        </Grid>
                    )}
                    <Grid item className="ml-auto">
                        <Button
                            variant="text"
                            style={{ textTransform: 'none' }}
                            onClick={() => setIsOpen(true)}
                        >
                            Modify
                        </Button>
                    </Grid>
                </Grid>
            )}
            <Grid
                item
                container
                id="golf-sidemenu"
                className={isOpen ? 'is-open' : ''}
                lg={3}
                sm={4}
                xs={12}
                direction="column"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                style={{ margin: 0 }}
            >
                <Grid item container className="title" justifyContent="flex-start">
                    Search for Tee Times
                </Grid>

                {!window.clientData?.restrictedToOneIsland && (
                    <FancyButtongroupSelect
                        label="ISLAND/REGION"
                        options={islandOptions}
                        value={islandOptions.find(e => e.name === filters.islands)?.id}
                        setValue={islandId => {
                            setFilters({
                                ...filters,
                                islands: islandOptions.find(e => e.id === islandId)?.name
                            });
                        }}
                    />
                )}
                <FancyPlayerCountSelect
                    label="Players"
                    value={filters.guests}
                    setValue={count => {
                        setFilters({
                            ...filters,
                            guests: count
                        });
                    }}
                />
                <Grid item container className="golf-picker" justifyContent="center">
                    <Grid item>
                        <p>DATE</p>
                        <Grid item>
                            <DatePickerDropdown
                                date={filters.checkInDate}
                                loading={loading}
                                setDate={date => setFilters({ ...filters, checkInDate: date })}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {!isMobileSize && (
                    <FancyButtongroupSelect
                        label="TIME"
                        options={GOLF_TIME_RANGES}
                        value={
                            GOLF_TIME_RANGES.find(e => {
                                return (
                                    e.value.fromTime === filters.startTimes.fromTime &&
                                    e.value.toTime === filters.startTimes.toTime
                                );
                            })?.id
                        }
                        setValue={timeId => {
                            setFilters({
                                ...filters,
                                startTimes: GOLF_TIME_RANGES.find(e => e.id === timeId)?.value
                            });
                        }}
                    />
                )}

                {!isMobileSize && (
                    <>
                        <Grid item container className="golf-options" justifyContent="center">
                            <PriceSlider
                                label="GREEN FEE"
                                className="price-slider"
                                setValue={setPriceCallback}
                                value={
                                    filters.price
                                        ? [filters.price.fromPrice, filters.price.toPrice]
                                        : [0, 200]
                                }
                                min={0}
                                max={200}
                                color="primary"
                            />
                        </Grid>
                    </>
                )}
                <Grid item>
                    <Button
                        variant="contained"
                        className="btn-golf-rounded wide-button"
                        color="primary"
                        disabled={notAllFiltersSelected}
                        onClick={() => {
                            loadActivities();
                            setIsOpen(false);
                        }}
                    >
                        Find Tee Times
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default withTheme(GolfActivityFilters);
